/* istanbul ignore file */
import React from 'react';
import ServiceBreadcrumbs from 'domain/organization/service/shared/ServiceBreadcrumbs';
import { CreateBreadcrumbItem } from 'framework/ui/BreadCrumbs';

const CreateServiceBreadcrumbs = () => {
  return (
    <ServiceBreadcrumbs>
      <CreateBreadcrumbItem entity="Service" />
    </ServiceBreadcrumbs>
  );
};

export default CreateServiceBreadcrumbs;
